import React, {useState, useEffect} from "react";
import {Field, Form, Formik} from "formik";
import {generate_uuid, transformTranslateFromValues, transformTranslateServerValues,} from "lib/helpers";
import {Loading, TextArea, TextField,} from "components/form";
import {required, validationWrapper} from "lib/formValidations";
import {useWizard} from "store/wizard";
import Modal from "components/Modal";
import { useList } from "store/list";
import * as Icons from "react-feather";
import { Link } from "react-router-dom";
import Delete from "../../Delete";
import { handleSuccessMessages } from "store/auth";
const Seasons = (props) => {
   const path = {
      baseRoute: "/panel/products",
      aliasName: "محصولات ها",
      type: "Movies",
    };
   const wizard = useWizard();
   const {
      dispatch,
    
      getList,
      list,

      remove,
    } = useList();
   const [showAddSeasons, setShowAddSeasons] = useState(false);
   const [showEditSeasons, setShowEditSeasons] = useState(false);
   const [showDeleteSeasons, setShowDeleteSeasons] = useState(false);
   const [showDelete, setShowDelete] = useState(false);
   const [chItem, setChItem] = useState(false);

   const [item, setItem] = useState([]);

   useEffect(() => {
      if (
         wizard.product
      ) {
         wizard.dispatch(wizard.getProductSeasons(wizard.product.id))
      }
   }, []);

   const _renderSeasons = () => {
      return wizard.seasons && wizard.seasons.length > 0 && wizard.seasons.map((item) => (
        <>
        <tr className="intro-x">

            <td className="text-center">
               {item.title}
            </td>
            <td className="">
               <p className="font-medium whitespace-nowrap text-center">
                  {item.summary.length>100?item.summary.slice(0,100):item.summary}
               </p>
            </td>
            <td className="table-report__action w-56">
               <div className="flex justify-center items-center">
                  <a className="flex items-center ml-3 cursor-pointer" onClick={() => {
                     setItem(item);
                     setShowEditSeasons(true)
                  }}> <Icons.CheckSquare className="w-4 h-4 ml-1"/> ویرایش </a>
                  <a className="flex items-center text-theme-6 cursor-pointer"
                     onClick={() => {
                        setItem(item);
                        setShowDeleteSeasons(true)
                     }}>
                     <Icons.Trash2 className="w-4 h-4 ml-1 "/>حذف </a>
               </div>
            </td>
         </tr>
         <tr className="intro-x bg-transparent" style={{background:"#eee"}}>
            <td className="intro-x shadow-none bg-gray-500" style={{background:"#eee"}}>قسمت ها :</td>
         </tr>
         <tr className="intro-x bg-transparent">
            <td colspan="3"  style={{background:"#eee"}}>
               <table className="table -mt-2 bg-transparent">
                        <thead>
                        <tr>
                           <th className="whitespace-nowrap text-center">شناسه</th>
                           <th className="whitespace-nowrap text-center">عنوان</th>
                           <th className="whitespace-nowrap text-center">عملیات</th>
                        </tr>
                        </thead>

                        <tbody>
                        {item.epesodes && item.epesodes.length > 0 && item.epesodes.map((item) => (
        <>
        <tr className="intro-x">

            <td className="text-center">
               {item.id}
            </td>
            <td className="text-center">
               {item&&item.detail?.title}
            </td>
           
            <td className="table-report__action w-56">
               <div className="flex justify-center items-center">
               <Link to={`/products/wizard/${item.id}`} onClick={() => { 
                  setTimeout(()=>{
                     window.location.reload()
                  },300)
                  }}>
                            <a className="flex items-center ml-3 cursor-pointer">
                              <Icons.CheckSquare className="w-4 h-4 ml-1" />
                              ویرایش
                            </a>
                          </Link>
                          <a
                            className="flex items-center text-theme-6 cursor-pointer"
                            onClick={() => {
                              setChItem(item);
                              setShowDelete(true);
                            }}
                          >
                            <Icons.Trash2 className="w-4 h-4 ml-1 " />
                            حذف{" "}
                          </a>
               </div>
            </td>
         </tr>
        
         </>))}

                        </tbody>
                  </table>
            </td>
         </tr>
         </>
      ));
   };

   if (wizard.seasonsLoad || wizard.load) {
      return (
         <>
            <div className="content">
               <div className="p-3 flex justify-center">
                  <Loading/>
               </div>
            </div>
         </>
      );
   }

   return (
      <>
      <Delete
        title="حذف محصول"
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, chItem.id, () => {
              handleSuccessMessages("عملیات با  انجام شد");
              wizard.dispatch(wizard.getProductSeasons(wizard.product.id))
              setShowDelete(false);
            })
          );
        }}
      />
         <AddSeasons
            close={() => setShowAddSeasons(false)}
            show={showAddSeasons}
            submit={(values) => {
               wizard.dispatch(wizard.submitProductSeason(wizard.product && wizard.product.id, values));
            }}
         />
         <EditSeasons
            close={() => setShowEditSeasons(false)}
            show={showEditSeasons}
            submit={(values) => {
               wizard.dispatch(wizard.updateProductSeason(wizard.product && wizard.product.id, item.id, values));
            }}
            item={item}
         />
         <DeleteSeasons
            close={() => setShowDeleteSeasons(false)}
            show={showDeleteSeasons}
            submit={() => {
               wizard.dispatch((wizard.deleteProductSeason(wizard.product && wizard.product.id, item.id)))
               setShowDeleteSeasons(false);
            }}
         />

         <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
            <div className="intro-y col-span-12 p-2 border-theme-21">
               <div className="flex justify-between items-center">
                  <h2>فصل ها :</h2>
                  <div>
                 
                  <Link to="/products/wizard" onClick={() => { 
                  setTimeout(()=>{
                     window.location.reload()
                  },300)
                  }}>
                   <a className="btn btn-primary btn-sm">  افزودن قسمت</a>
                  </Link>
                  <button
                     className="btn btn-sm btn-primary mr-2"
                     type="button"
                     onClick={() => setShowAddSeasons(true)}
                  >
                     افزودن فصل
                  </button>

                  </div>
                 
               </div>
               <hr className="my-2"/>
               <table className="table table-report -mt-2">
                  <thead>
                  <tr>
                     <th className="whitespace-nowrap text-center">عنوان</th>
                     <th className="whitespace-nowrap text-center">خلاصه</th>
                     <th className="whitespace-nowrap text-center">عملیات</th>
                  </tr>
                  </thead>

                  <tbody>
                  {_renderSeasons()}


                  </tbody>
               </table>
            </div>
            <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
               <button
                  className="btn btn-secondary w-24"
                  type="button"
                  onClick={() => wizard.dispatch(wizard.previous())}
               >
                  قبلی
               </button>
               {wizard && wizard.mode == "update" && (
                  <button
                     className="btn btn-secondary w-24 mr-2"
                     type="button"
                     onClick={() => wizard.dispatch(wizard.next())}
                  >
                     بعدی
                  </button>
               )}
            </div>
         </div>

      </>
   );
};

export default Seasons;

export function AddSeasons(props) {
   return (
      <Modal show={props.show} handleClose={props.close} title="افزودن تریلر">
         <Formik
            key="fromik_p_trailer"
            initialValues={{uuid: generate_uuid()}}
            onSubmit={(values, {setSubmitting}) => {
               props.submit(transformTranslateFromValues(values));
               props.close();
               setSubmitting(false);
            }}
         >
            {({isSubmitting, dirty, handleSubmit}) => (
               <Form>
                  <div className="modal-body gap-y-3">
                     <div className="intro-x grid md:grid-cols-2 md:gap-3">
                        <div>
                           <Field
                              placeholder="عنوان فصل"
                              label="عنوان فصل :"
                              name="title"
                              component={TextField}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div>
                           <Field
                              placeholder="عنوان انگلیسی فصل"
                              label="عنوان انگلیسی فصل :"
                              name="_en*title*text"
                              component={TextField}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div>
                           <Field
                              placeholder="خلاصه فصل"
                              label="خلاصه فصل :"
                              name="summary"
                              component={TextArea}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div>
                           <Field
                              placeholder="خلاصه انگلیسی فصل"
                              label="خلاصه انگلیسی فصل :"
                              name="_en*summary*text"
                              component={TextArea}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                     </div>
                  </div>
                  <div className="modal-footer text-right">
                     <button
                        className="btn btn-primary w-20"
                        type="button"
                        onClick={handleSubmit}
                        disabled={!!(isSubmitting || !dirty)}
                     >
                        {" "}
                        {isSubmitting ? <Loading/> : "ذخیره"}
                     </button>
                     <button
                        type="button"
                        disabled={isSubmitting}
                        onClick={props.close}
                        className="btn btn-outline-secondary w-20 mr-1"
                     >
                        انصراف
                     </button>
                  </div>
               </Form>
            )}
         </Formik>
      </Modal>
   );
}

export function EditSeasons(props) {
   return (
      <Modal show={props.show} handleClose={props.close} title="ویرایش  فصل">
         <Formik
            key="fromik_p_season_edit"
            initialValues={{...transformTranslateServerValues(props.item)}}
            onSubmit={(values, {setSubmitting}) => {
               props.submit(transformTranslateFromValues(values));
               props.close();
               setSubmitting(false);
            }}
         >
            {({isSubmitting, dirty, handleSubmit}) => (
               <Form>
                  <div className="modal-body gap-y-3">
                     <div className="intro-x grid md:grid-cols-2 md:gap-3">
                        <div>
                           <Field
                              placeholder="عنوان فصل"
                              label="عنوان فصل :"
                              name="title"
                              component={TextField}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div>
                           <Field
                              placeholder="عنوان انگلیسی فصل"
                              label="عنوان انگلیسی فصل :"
                              name="_en*title*text"
                              component={TextField}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div>
                           <Field
                              placeholder="خلاصه فصل"
                              label="خلاصه فصل :"
                              name="summary"
                              component={TextArea}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div>
                           <Field
                              placeholder="خلاصه انگلیسی فصل"
                              label="خلاصه انگلیسی فصل :"
                              name="_en*summary*text"
                              component={TextArea}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                     </div>
                  </div>
                  <div className="modal-footer text-right">
                     <button
                        className="btn btn-primary w-20"
                        type="button"
                        onClick={handleSubmit}
                        disabled={!!(isSubmitting || !dirty)}
                     >
                        {isSubmitting ? <Loading/> : "ذخیره"}
                     </button>
                     <button
                        type="button"
                        disabled={isSubmitting}
                        onClick={props.close}
                        className="btn btn-outline-secondary w-20 mr-1"
                     >
                        انصراف
                     </button>
                  </div>
               </Form>
            )}
         </Formik>
      </Modal>
   );
}

export function DeleteSeasons(props) {

   return (
      <>
         <Modal show={props.show} handleClose={props.close} title={props.title}>
            <div className="modal-body gap-y-3">
               <h4>آیا از حذف این فصل مطمئن هستید؟</h4>
            </div>
            <div className="modal-footer flex justify-between">
               <button className="btn btn-danger w-20" type="button" onClick={props.submit}>
                  حذف
               </button>
               <button type="button" onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">
                  انصراف
               </button>
            </div>
         </Modal>
      </>
   );
}



